import { fetchStatistics, fetchCommonStatistics } from './actions';
import { login } from '../auth/actions';
import { fetchDevices } from '../devices/actions';
import { take, call, select, cancelled } from 'redux-saga/effects';
import { apiRequest } from '../../utils/api';
import { bindAsyncAction } from '../../utils/sagas';
import { changeCurrentDevice } from '../../components/Header/actions';

const worker = bindAsyncAction(
  fetchStatistics,
  function* getStatistics(params) {
    return yield call(apiRequest, params);
  }
);

const commonWorker = bindAsyncAction(
  fetchCommonStatistics,
  function* getCommonStatistics(params) {
    return yield call(apiRequest, params);
  }
);

export default function* statisticsSaga() {
  yield take(login.done.type);
  yield take(fetchDevices.done.type);

  const devices = yield select(state => state.devices.devices);
  if (devices.length) {
    yield call(fetchStatisticsSaga);

    while (true) {
      yield take(changeCurrentDevice.type);
      yield call(fetchStatisticsSaga);
    }
  }
}

function* fetchStatisticsSaga() {
  const devicesIds = yield select(state => state.devices.devices.map(d => d.id));

  try {
    yield call(commonWorker, {
      url: '/api/v3/Statistics',
      params: {
        Devices: devicesIds,
      },
    });
    for (const id of devicesIds) {
      yield call(worker, {
        url: '/api/v3/Statistics',
        params: {
          Devices: [id],
        },
      });
    }
  } catch (e) {
    if(yield cancelled()) {

    } else {
      console.log('-----------')
      console.log(e)
      console.log('-----------')
      // throw new Error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/statistics/index.js